import { faUser } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import React from "react"

export const UserAvatar = () => {
    return (<FontAwesomeIcon icon={faUser} />)
}